import { makeStyles } from '@material-ui/core/styles';

export const useEditFormStyles = makeStyles(() => ({
  form: {
    height: '85%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  textFieldsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '380px',
    height: 'auto',
    paddingLeft: '85px',
    marginTop: '20px',
    marginBottom: '15px',
  },
}));
